import { useTheme } from '@mui/material/styles';
import type { Theme } from '@mui/material/styles';
import { navigate } from 'gatsby';
import React, { memo } from 'react';

import {
  CompletedLine,
  ContainerHorizontal,
  ContainerHorizontalFull,
  HorizontalStepper,
  IncompletedLine,
  TextWrapper,
  Title,
} from './HorizontalProcessStepper.style';
import ProcessStepCircle from './ProcessStepCircle';

type StepType = {
  name: string;
  link: string;
  disabled: boolean;
  visible: boolean;
};

function HorizontalProcessStepper({
  steps = [],
  step = 0,
}: {
  steps: StepType[];
  step: number;
}) {
  function getColor(index: number, step: number, theme: Theme) {
    if (step === index) {
      return {
        innerColor: theme.palette.grey.A200,
        outerColor: theme.palette.primary.main,
      };
    } else if (step <= index) {
      return {
        innerColor: theme.palette.primary.main,
        outerColor: theme.palette.grey.A200,
      };
    }
    return {
      innerColor: theme.palette.primary.main,
      outerColor: theme.palette.grey.A200,
    };
  }

  function selectCircle(step: StepType) {
    const { link, disabled } = step;
    if (!disabled && link) {
      navigate(link);
    }
  }

  const theme = useTheme();

  return (
    <ContainerHorizontalFull>
      {steps.map(({ name, link, disabled, visible }, index) => {
        if (visible) {
          const { innerColor, outerColor } = getColor(index, step, theme);
          return (
            <HorizontalStepper key={name}>
              <ContainerHorizontal>
                <ProcessStepCircle
                  hover={!disabled && Boolean(link)}
                  innerColor={innerColor}
                  onClick={() => selectCircle(steps[index])}
                  outerColor={outerColor}
                />
                {index !== steps.length - 1 &&
                  (index < step ? <CompletedLine /> : <IncompletedLine />)}
              </ContainerHorizontal>

              <TextWrapper>
                <Title selected={step === index}>{name}</Title>
              </TextWrapper>
            </HorizontalStepper>
          );
        }
        return null;
      })}
    </ContainerHorizontalFull>
  );
}

export default memo(HorizontalProcessStepper);
